import type { ToastServiceMethods } from 'primevue/toastservice'

// The toast service captured once from App.vue's setup. PrintSuccess/PrintError are called from
// async handlers (after an `await` in a dialog save or a list-load error) where useToast()'s
// inject() throws "No PrimeVue Toast provided!" — which previously aborted the success branch, so
// the dialog never closed, its button spinner stuck, and the table never refreshed. Capturing the
// service at setup and reusing it here makes the toasts work from anywhere.
let service: ToastServiceMethods | null = null

export const registerToast = (instance: ToastServiceMethods) => {
    service = instance
}

export const PrintSuccess = (message: string) => {
    service?.add({ severity: 'success', summary: message, life: 3000 })
}

export const PrintError = (message: string) => {
    service?.add({ severity: 'error', summary: message, life: 5000 })
}
